import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type AcceptIncomingCallCrmMetadata = {
  vendorCallId: string;
};

export type AcceptIncomingCallRequest = Pick<
  Call<AcceptIncomingCallCrmMetadata>,
  'crmMetadata'
>;

export interface AcceptIncomingCallRepository {
  updateIncomingCall(call: AcceptIncomingCallRequest): Promise<void>;
}

export interface AcceptIncomingCallEventPublisher {
  publish(): Promise<void>;
}

export interface AcceptIncomingCallUsecase
  extends BaseUsecase<AcceptIncomingCallRequest, void> {
  run(call: AcceptIncomingCallRequest): Promise<void>;
}

export class AcceptIncomingCall implements AcceptIncomingCallUsecase {
  constructor(
    private repository: AcceptIncomingCallRepository,
    private publisher: AcceptIncomingCallEventPublisher,
  ) {}

  async run(call: AcceptIncomingCallRequest): Promise<void> {
    await Promise.all([
      this.publisher.publish(),
      this.repository.updateIncomingCall(call),
    ]);
  }
}
